module.exports = __webpack_public_path__ + "img/H01046-02.f9363ef6.jpg";